<template lang="pug">
div
  div.select_options(:class="{disabled:disabled,checked:checkAll,noCheckBox:!select.showCheckBox,d_row: select.direction !== 'column'}" @click="clickHandle")
    slot
      div.option_warp
        span(v-if="select.showCheckBox")
          i.icon(v-show="!checkAll")
          i.icon.checked(v-show="checkAll")
        span.contentLabel {{label || value}}
</template>

<script>
import emitter from '../../src/mixins/emitter.js'
export default {
  name: 'km-select-all-button',
  inject: ['select'],
  mixins: [emitter],
  model: {
    prop: 'checkAll',
    event: 'change'
  },
  props: {
    disabled: {
      default: false
    },
    value: {
      required: true
    },
    checkAll: {
      required: true,
      default: false
    },
    label: ''
  },
  methods: {
    clickHandle () {
      !this.disabled && this.$emit('change', !this.checkAll)
    },
    setLabel (v) {
      if (v) {
        this.dispatch('kmSelect', 'selectAll', this.label || this.value)
      } else {
        this.dispatch('kmSelect', 'selectAll', '')
      }
    }
  },
  watch: {
    checkAll: {
      immediate: true,
      handler (v) {
        this.setLabel(v)
      }
    }
  },
  mounted () {
    this.setLabel(this.checkAll)
  },
}
</script>

<style lang="less" scoped>
.select_options {
  cursor: pointer;
  margin-left: 10px;
  display: inline-block;
}
i.icon {
  display: block;
  width: 16px;
  height: 16px;
  background-image: url(/static/images/icon_common.png);
}
i.icon.checked {
  background-position-x: -16px;
}
.d_row {
  padding: 0 6px;
  color: #21bd73;
  margin-left: 4px;
  margin-right: 4px;
}
.disabled {
  cursor: not-allowed;
  color: #aaa;
}
.noCheckBox:hover {
  background: #f2f9f6;
}
.noCheckBox.checked {
  background: #24cc7c;
  color: white;
}
.option_warp {
  display: flex;
  align-items: center;
}
.contentLabel{
  margin-left: 6px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/ui/components/km-select/select-all-button.vue